export const content = {
    domain: "Onemain Financial",
    footer: "onemainsfinancial.com",
    title1: "The Better Way To Find A Loan.",
  };
  